export function getItem(key: string): string {
  const match = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`)
  return match ? match.pop() : ''
}
